module.exports = __webpack_public_path__ + "static/electrogator-dc095bbc7eae0134fb7af73a945fdd25.jpg";